import { GetChargingConnectorRequest } from '../../api/requests/charging-connector-request.ts';
import { useQuery } from '@tanstack/react-query';
import { getChargingConnector } from '../../api/charging-connector.ts';

export default function useChargingConnector(
  request: GetChargingConnectorRequest,
) {
  const { evseId, connectorId } = request;
  return useQuery({
    queryKey: ['evses', evseId, 'chargingConnectors', connectorId],
    queryFn: async () => getChargingConnector(request),
    enabled: !!evseId && !!connectorId,
  });
}
